import { Subject } from 'rxjs';
import { Component, OnInit, Input, Pipe, PipeTransform, ViewChild, QueryList, ViewChildren } from '@angular/core';
import { Machine } from './machine';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { MachineService } from './machineService';
import { Ticket } from '../ticket/ticket';
import { TicketService } from '../ticket/ticketService';
import { State } from '../state/state';
import { StateService } from '../state/stateService';
import * as html2pdf from 'html2pdf.js';
import { UserService } from '../_services/user.service';
import { ClientService } from '../client/clientservice';
import { User } from '../user/user';
import { Client } from '../client/client';
import { Authenticate } from '../authenticate/authenticate';
import { LocationService } from '../location/locationService';
import { embeddedViewStart } from '@angular/core/src/render3/instructions';


@Component({
    selector: 'app-machine',
    templateUrl: './machine.component.html',
    styleUrls: ['../app.component.less', './machine.component.less']
})
export class MachineComponent implements OnInit {

    //#region Variables
    @Input() inMachines: Machine[];
    @Input() inClient: Client;
    machines: Machine[];
    machine = new Machine;
    location: Location;
    tickets: Ticket[];
    _states: State[];
    _selectedstateid: number;
    state = new State;
    querycriteria: string;
    searchquery: string;
    currentuser: User;
    currentclient: Client;
    auth: Authenticate;
    private userRole: string;
    private jwt: string;
    private userrole: string;
    locations: Location[];
    selectedLocation: string;
    p: Number = 1;
    count: Number = 5;
    stid = 0;
    showUpdate = true;

    id = +this.route.snapshot.paramMap.get('id');

    collapse = false;
    showTickets: boolean = false; // Initial state of Tickets List (expanded)
    showMaintenance: boolean = false; // Initial state of Maintenance List (expanded)
  
  //#endregion

    constructor(private http: HttpClient,
        private route: ActivatedRoute,
        private machineservice: MachineService,
        private ticketservice: TicketService,
        private stateservice: StateService,
        private userservice: UserService,
        private clientservice: ClientService,
        private locationservice: LocationService) { }

    async ngOnInit() {
        this.querycriteria = "shortname";
        this.currentclient = this.inClient;

        this.auth = JSON.parse(sessionStorage.getItem('currentUser'));
        this.jwt = this.auth.jwt;
        let role = this.auth.user.role.name;
        this.userrole = role;
        this.currentuser = this.auth.user;

        if (role == "Authenticated" || this.userrole == "Administrator") {
            this.getMachineById(this.id, 0);
        }
        else {
            if (role = "clientsrole") {
                console.log("we are in client roles");
                var cID = this.currentuser.client.id;
                console.log("CID = " + cID);
                this.showUpdate = false;
                await this.clientservice.getClientById(cID).subscribe(resp => this.currentclient = resp);
                await this.machineservice.getMachine(this.id).subscribe(resp => this.machine = resp);
                await this.locationservice.getLocationsByClId(cID).subscribe(resp => this.locations = resp);
                await this.ticketservice.getTicksetofMachineLight(this.id).subscribe(resp => this.tickets = resp);

            }
        }
    }

  
    getMachineById(id: number, clientid: number) {
        this.machineservice.getMachine(id).subscribe(machine => {
            var clientofmachine = machine.client.id;
            var rr = this.userservice.getUserRole();

            if (clientofmachine != clientid) {
            }
            if (rr == "Authenticated" || this.userrole == "Administrator") {
                this.machine = machine;
                this.state = this.machine.state;
                this.stid = this.machine.state.id;
                this.ticketservice.getTicksetofMachineLight(id).subscribe(rettickets => {
                    this.tickets = rettickets.reverse();
                });
                this.state = this.machine.state;
                this.stateservice.getStates().subscribe(states => this._states = states);
            }

            if (clientofmachine == clientid) {
                this.machine = machine;
                this.state = this.machine.state;
                this.ticketservice.getTicksetofMachineLight(id).subscribe(rettickets => {
                    this.tickets = rettickets.reverse();
                });
                this.state = this.machine.state;
                this.stid = this.machine.state.id;
                this.stateservice.getStates().subscribe(states => this._states = states);
            }
        });
    }

    search(shortname) {

        if (this.userrole == "Authenticated" || this.userrole == "Administrator") {
            this.machineservice.getMachineByCriteriaAdmin(this.querycriteria, shortname, this.jwt).subscribe(machines => this.machines = machines);

        } else {
            this.machineservice.getMachineByCriteria(this.querycriteria, shortname, this.currentuser.client.id, this.jwt).subscribe(machines => this.machines = machines);
        }
        this.p = 1;

    }


    locChanged(): void {
        var seek = this.selectedLocation.substring(0, this.selectedLocation.indexOf(':'));

        if (this.userrole == "Authenticated" || this.userrole == "Administrator") {
            this.machineservice.getMachineByLocationIdAdmin("location", seek, this.jwt).subscribe(machines => this.machines = machines);

        } else {
            this.machineservice.getMachineByLocationId("location", seek, this.currentuser.client.id, this.jwt).subscribe(machines => this.machines = machines);
        }
        this.p = 1;
    }

    updateState() {

        this.machine.state.id = this.stid;
        this.machineservice.changeState(this.machine.id, this.stid).subscribe(resp => {
            this.ngOnInit();
        });
    }


    goBack(): void {
        this.location.reload;
    }


    onExportClick() {
        const options = {
            filename: 'myFirstExport.pdf',
            image: { type: 'jpeg' },
            html2canvas: {},
            jsPDF: { orientation: 'portrait' }

        };
        const content: Element = document.getElementById('machineview');
        html2pdf()
            .from(content)
            .set(options)
            .save();

    }

    onCollaps() {
        var coll = document.getElementById("collapseExample");
        if (this.collapse == true) {
            coll.style.display = "";
            this.collapse = false;
        }
        else {
            coll.style.display = "none";
            this.collapse = true;
        }
        ;
    }




}